import { Component, OnInit, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-contact-menu',
  templateUrl: './contact-menu.component.html',
  styleUrls: ['./contact-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {'id': 'appContactMenu'}
})
export class AccountContactMenuComponent implements OnInit {
  @Output() onExportData = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }


  exportData() {
    this.onExportData.emit();
  }

  deletePersonalData() {
  }

  deleteRegistry() {

  }

}
